'use strict';

import {
    apiUrl
} from '../../app.api.config';

export default class DocumentService {
    /*@ngInject*/
    constructor($http) {
        this.$http = $http;
    }

    print = function (id, email, hash) {
        window.open(apiUrl().API_URL + '/documents/print/' + id + '/' + email + '/' + hash, '_self');
    };
    printOczfp = function (id, email, hash) {
        window.open(apiUrl().API_URL + '/documents/oczfp/print/' + id + '/' + email + '/' + hash, '_self');
    };
    printNnw = function (id, email, hash) {
        window.open(apiUrl().API_URL + '/documents/nnw/print/' + id + '/' + email + '/' + hash, '_self');
    };
}



// WEBPACK FOOTER //
// ./client/app/shared/model/Document.js